// Composed by hand rather than with toLocaleDateString: en-GB now abbreviates September as "Sept", and en-US puts the
// month first, so neither gives the "18 Sep 2026" the quiz screens are designed with.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const twoDigits = (value: number) => String(value).padStart(2, '0')

/** "18 Sep 2026", or "18 Sep" without the year. */
export function formatQuizDate(date: Date, withYear = true): string {
    const day = `${date.getDate()} ${MONTHS[date.getMonth()]}`
    return withYear ? `${day} ${date.getFullYear()}` : day
}

/** "23 Sep 2026, 14:32", or "23 Sep, 14:32" without the year. Always the 24-hour clock. */
export function formatQuizDateTime(date: Date, withYear = true): string {
    return `${formatQuizDate(date, withYear)}, ${twoDigits(date.getHours())}:${twoDigits(date.getMinutes())}`
}
